var _defs, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompositeAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1.04767in",
    height: "0.952362in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 138 125",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2974850415712"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    style: {
      fill: "none",
      stroke: "#999999",
      strokeWidth: 0.912967
    },
    d: "M20 125c2,-4 3,-4 3,-6 0,-2 1,-4 -2,-9 -3,0 -6,2 -8,0 0,0 0,-2 0,-3 0,-1 -1,0 -1,-1 0,0 0,-1 0,-2 0,0 -2,-1 -2,-1 1,-1 0,-3 0,-3 0,0 -2,1 -2,0 0,-3 3,-6 3,-8 0,-1 0,-2 -1,-2 -1,0 0,-5 0,-6 0,-1 -2,-2 -1,-3 1,-2 2,-4 4,-5 2,-1 4,-3 6,-4 4,-2 7,-2 13,-1 3,1 3,1 5,2 11,6 8,16 8,23 -1,2 -2,5 -4,6 -3,1 -3,1 -5,4 0,2 0,2 3,6 1,2 2,3 4,4 1,1 3,5 4,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    style: {
      fill: "none",
      stroke: "#999999",
      strokeWidth: 0.912967
    },
    d: "M118 125c-2,-4 -3,-4 -3,-6 -1,-2 -1,-4 2,-9 3,0 6,2 8,0 0,0 0,-2 0,-3 0,-1 1,0 1,-1 0,0 0,-1 0,-2 0,0 2,-1 1,-1 0,-1 0,-3 0,-3 1,0 3,1 3,0 0,-3 -3,-6 -3,-8 0,-1 0,-2 0,-2 2,0 1,-5 1,-6 0,-1 1,-2 1,-3 -1,-2 -2,-4 -4,-5 -2,-1 -4,-3 -6,-4 -4,-2 -7,-2 -13,-1 -4,1 -3,1 -6,2 -10,6 -7,16 -7,23 1,2 2,5 4,6 2,1 3,1 4,4 1,2 1,2 -2,6 -1,2 -2,3 -4,4 -1,1 -3,5 -4,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    style: {
      fill: "none",
      stroke: "#999999",
      strokeWidth: 0.912967,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M103 40c-1,-1 -2,-2 -2,-3 -1,-2 -1,-2 -1,-3 -1,0 -1,2 -3,-2 0,-2 -1,-6 -1,-8 0,-1 1,-1 2,-1 -5,-9 -1,-9 -1,-11 -1,-6 0,-9 7,-11 4,-1 11,0 16,2l-2 0c5,1 7,3 8,6 3,6 1,10 0,13l0 -1c-1,-1 -1,-1 -1,-1l-1 4c1,0 1,0 1,1 -1,2 -1,4 -2,6 0,2 -1,3 -2,2 -1,3 -2,5 -4,7 -1,1 -4,5 -7,4 -2,1 -6,-3 -7,-4zm13 -7c-2,1 -3,3 -6,3 -2,0 -4,-2 -5,-3 4,1 7,1 11,0zm-33 22c2,-3 5,-3 8,-4 6,-2 8,-3 10,-4 1,-2 1,-3 2,-7 2,2 5,5 7,4 3,1 6,-2 7,-4 2,4 2,6 3,7 1,1 8,3 9,3 4,1 7,2 8,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    style: {
      fill: "none",
      stroke: "#999999",
      strokeWidth: 0.912967,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M20 40c0,-1 -2,-2 -2,-3 -1,-2 -1,-2 -1,-3 0,0 -1,2 -2,-2 -1,-2 -2,-6 -2,-8 0,-1 1,-1 2,-1 -5,-9 -1,-9 -1,-11 -1,-6 1,-9 7,-11 4,-1 12,0 16,2l-2 0c5,1 7,3 9,6 2,6 0,10 -1,13l0 -1c-1,-1 0,-1 -1,-1l-1 4c1,0 1,0 1,1 0,2 -1,4 -2,6 0,2 -1,3 -2,2 -1,3 -2,5 -3,7 -2,1 -5,5 -8,4 -2,1 -6,-3 -7,-4zm3 -7c3,1 6,1 9,0m-32 22c2,-3 5,-3 8,-4 6,-2 9,-3 10,-4 1,-2 1,-3 2,-7 2,2 5,5 7,4 3,1 6,-2 8,-4 1,4 1,6 2,7 1,1 8,3 9,3 4,1 7,2 9,5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompositeAvatar);
export default __webpack_public_path__ + "static/media/CompositeAvatar.ad9c471506f4981469307bcd9fbaa521.svg";
export { ForwardRef as ReactComponent };